export default __webpack_public_path__ + "static/separating-10c660235ccf9e7404d895cd21a0940d.png";